module.exports = __webpack_public_path__ + "img/logo-wall.07524517.png";